<template>
  <div class="h-100">
    <h1>{{ title }}</h1>
    <b-container fluid class="px-0">
      <b-row>
        <b-col class="py-1">
          <!-- clster enrollment chart -->
          <ClusterEnrollment />
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col lg="12" xl="4" class="py-1">
          <!-- subject retention donut -->
          <SubjectRetention />
        </b-col>
        <b-col lg="12" xl="4" class="py-1">
          <!-- subject infection donut -->
          <PositiveInfections />
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import ClusterEnrollment from "@/components/metrics/uganda/ClusterEnrollment.vue";
import SubjectRetention from "@/components/metrics/uganda/SubjectRetention.vue";
import PositiveInfections from "@/components/metrics/uganda/PositiveInfections.vue";

import { mapGetters } from 'vuex';

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    ClusterEnrollment,
    SubjectRetention,
    PositiveInfections
  },
  data() {
    return {
      title: "AEGIS Data Portal Dashboard",
    }
  },
  created: function() {
    this.init();
  },
  computed: {
    ...mapGetters('user', ['inMyGroups'])
  },
  methods: {
    init: function() {
      // For here to check that token is still valid and launch login dialog if expired.
      HTTP.get("/users/api/me/")
      .then(() => {})
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
  },
};
</script>

<style></style>
